var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpain2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Spain@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-662.000000, -621.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    id: "Spain"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(592.000000, 551.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFCE54",
    fillRule: "nonzero",
    x: 0.63,
    y: 10.51,
    width: 70,
    height: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.27,0.56 L7,0.56 C5.31322312,0.56 3.69553224,1.23006898 2.50280087,2.42279941 C1.3100695,3.61552983 0.64,5.23321945 0.64,6.91999499 L0.64,10.5599921 L70.64,10.5599921 L70.64,6.91999499 C70.6400021,5.23148541 69.96856,3.61227848 68.773665,2.41926018 C67.5787699,1.22624188 65.9585088,0.557345111 64.27,0.56 Z",
    id: "Shape",
    fill: "#ED5565",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.63,41.2 C0.63,42.8867769 1.3000695,44.5044678 2.49280087,45.6971991 C3.68553224,46.8899305 5.30322312,47.56 6.99,47.56 L64.26,47.56 C65.9467769,47.56 67.5644678,46.8899305 68.7571991,45.6971991 C69.9499305,44.5044678 70.62,42.8867769 70.62,41.2 L70.62,37.56 L0.62,37.56 L0.63,41.2 Z",
    id: "Shape",
    fill: "#ED5565",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.71,27.13 L11.71,30 C11.71,31.6568542 13.0531458,33 14.71,33 L16.41,33 L16.41,27.17 L11.71,27.13 Z",
    id: "Shape",
    fill: "#F6D660",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.21,27.13 L13.21,32.55 C13.3692673,32.6418249 13.5366381,32.7188155 13.71,32.78 L13.71,27.13 L13.21,27.13 Z",
    id: "Shape",
    fill: "#ED5565",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.13,27.13 L12.13,31.48 C12.266128,31.7185321 12.4343661,31.9372416 12.63,32.13 L12.63,27.13 L12.13,27.13 Z",
    id: "Shape",
    fill: "#ED5565",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3,27.13 L14.3,32.92 C14.4331849,32.9288988 14.5668151,32.9288988 14.7,32.92 L14.8,32.92 L14.8,27.09 L14.3,27.13 Z",
    id: "Shape",
    fill: "#ED5565",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#ED5565",
    fillRule: "nonzero",
    x: 15.38,
    y: 27.13,
    width: 1,
    height: 5.83
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#ED5565",
    fillRule: "nonzero",
    x: 11.71,
    y: 21.83,
    width: 4.69,
    height: 5.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.09,30 L21.09,27.16 L16.4,27.16 L16.4,33 L18.1,33 C19.7529477,32.9944901 21.0900092,31.6529569 21.09,30 Z",
    id: "Shape",
    fill: "#ED5565",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 16.4,
    y: 21.83,
    width: 4.69,
    height: 5.29
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#ED5565",
    strokeWidth: 0.5,
    fill: "#4A89DC",
    fillRule: "nonzero",
    cx: 16.4,
    cy: 27.13,
    r: 1.52
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 8.75,
    y: 21.83,
    width: 1.42,
    height: 9.71,
    rx: 0.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 22.63,
    y: 21.83,
    width: 1.42,
    height: 9.71,
    rx: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.93,18.39 C20.93,18.39 20.93,18.34 20.93,18.31 C20.93,17.51 18.93,16.86 16.36,16.86 C13.79,16.86 11.79,17.51 11.79,18.31 C11.7867241,18.3432528 11.7867241,18.3767472 11.79,18.41 L12.79,19.56 L13.15,19.46 C13.2966387,19.448837 13.4411931,19.4185814 13.58,19.37 C13.7751041,19.2839474 13.9755134,19.210464 14.18,19.15 L14.84,19.26 L15.3,18.95 L15.84,19.16 L16.35,18.84 L16.83,19.17 L17.41,18.91 C17.5796516,19.0400163 17.7566078,19.1602129 17.94,19.27 C17.94,19.27 18.44,19.03 18.44,19.03 L18.79,19.4 L19.3,19.21 L19.7,19.65 L20.93,18.39 Z",
    id: "Shape",
    fill: "#ED5565",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,19.4 L18.64,19.03 C18.64,19.03 18.16,19.27 18.12,19.27 C17.9301299,19.1602965 17.7465127,19.0401106 17.57,18.91 L16.96,19.17 L16.45,18.84 L15.91,19.16 L15.34,18.95 L14.86,19.26 L14.16,19.15 C13.9457259,19.2104674 13.7353359,19.2839369 13.53,19.37 C13.3842902,19.4184604 13.23314,19.4486905 13.08,19.46 L12.7,19.56 L12.99,19.82 L13.39,20.52 L19.39,20.52 L19.79,19.82 L19.99,19.65 L19.57,19.21 L19,19.4 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 16.39,
    cy: 20.51,
    rx: 2.71,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.07,19.81 C13.5,19.51 14.44,19.36 16.4,19.36",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.51,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.39,19.36 C18.39,19.36 19.29,19.51 19.72,19.81",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.51,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 16.39,
    cy: 20.51,
    rx: 2.71,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#ED5565",
    fillRule: "nonzero",
    cx: 16.39,
    cy: 20.51,
    rx: 2.71,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.21,17.58 C14.0087945,17.3806828 13.9106043,17.0998022 13.9438088,16.8185399 C13.9770134,16.5372777 14.1379117,16.2869839 14.38,16.14 C14.9192511,15.8564363 15.5697614,15.8870486 16.08,16.22 L16.39,16.42 L16.7,16.22",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,18.31 C11.7957301,18.0960042 11.6912131,17.8057654 11.7121554,17.5106691 C11.7330977,17.2155728 11.877556,16.9430032 12.11,16.76 C12.6503488,16.4204519 13.3140442,16.3397817 13.92,16.54",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.58,17.58 C18.7812055,17.3806828 18.8793957,17.0998022 18.8461912,16.8185399 C18.8129866,16.5372777 18.6520883,16.2869839 18.41,16.14 C17.8707489,15.8564363 17.2202386,15.8870486 16.71,16.22",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.78,18.31 C20.9842699,18.0960042 21.0887869,17.8057654 21.0678446,17.5106691 C21.0469023,17.2155728 20.902444,16.9430032 20.67,16.76 C20.1296512,16.4204519 19.4659558,16.3397817 18.86,16.54",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.39,17.37 L16.39,16.43",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2,19.28 C19.92,19.75 19.2,19.6 19.55,18.99 C19.55,18.99 19.33,19.48 18.89,19.4 C18.62,19.4 18.48,19.1 18.55,18.74 C18.523439,19.0525519 18.2531982,19.2873513 17.94,19.27 C17.44,19.27 17.49,18.6 17.49,18.6 C17.49,18.6 17.49,19.19 16.94,19.17 C16.7914464,19.1647894 16.6510592,19.1007309 16.5497697,18.9919385 C16.4484803,18.8831462 16.3945999,18.7385469 16.4,18.59 C16.4109622,18.7419055 16.3595809,18.8917234 16.2576972,19.0049275 C16.1558136,19.1181315 16.0122169,19.1849557 15.86,19.19 C15.32,19.19 15.31,18.62 15.31,18.62 C15.31,18.62 15.31,19.25 14.86,19.29 C14.5468018,19.3073513 14.276561,19.0725519 14.25,18.76 C14.31,19.12 14.18,19.37 13.91,19.42 C13.47,19.5 13.25,19.01 13.25,19.01 C13.57,19.63 12.88,19.77 12.6,19.3",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#4A89DC",
    fillRule: "nonzero",
    cx: 16.39,
    cy: 15.72,
    r: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain2X);
export default __webpack_public_path__ + "static/media/Spain@2x.5cc48da2f12812c81a679fc3f2f4d576.svg";
export { ForwardRef as ReactComponent };